import Policeman from '@/utils/Policeman/policeman'

const sidebarItems = () => {
  return {
    items: [
      {
        name: 'Dashboard',
        url: '/dashboard',
        icon: 'icon-pie-chart',
        roles: Policeman.getRoles('dashboard', 'index')
      },
      {
        name: 'Objects',
        url: '/structures',
        icon: 'icon-speedometer',
        roles: Policeman.getRoles('structure', 'index')
      },
      {
        name: 'Users',
        url: '/users',
        icon: 'icon-people',
        roles: Policeman.getRoles('user', 'index')
      },
      {
        name: 'Projects',
        url: '/projects',
        icon: 'icon-event',
        roles: Policeman.getRoles('project', 'index')
      },
      {
        name: 'Inspections',
        url: '/checklists',
        icon: 'icon-list',
        roles: Policeman.getRoles('checklist', 'index')
      }
    ]
  }
}

export { sidebarItems }



// WEBPACK FOOTER //
// ./src/_nav.js